module.exports = __webpack_public_path__ + "img/alert.71e8c083.jpg";